import { useMemo } from 'react';
import { type PermissionSupplier } from '../../product-router/product/check-product-permissions';
import { BitbucketScope } from './types';
import { fetchBitbucketWorkspacesData } from '../../../common/analytics/bitbucket-workspaces-utils';

/**
 * Bitbucket permission supplier that uses the /user/workspaces API instead of the scopes API.
 * Repository search requires Bitbucket workspace context.
 * Permission is granted only when the user has access to at least one workspace with a valid uuid.
 * Uses the shared bitbucket-workspaces-utils to fetch data, which provides caching.
 */
export const useBitbucketWorkspacesPermissionSupplier = (
	overridenPermissionsSupplier?: PermissionSupplier,
) => {
	return useMemo(() => {
		if (overridenPermissionsSupplier) {
			return overridenPermissionsSupplier;
		}

		return async (): Promise<string[]> => {
			try {
				const { selectedBitbucketWorkspace } = await fetchBitbucketWorkspacesData();
				return selectedBitbucketWorkspace ? [BitbucketScope.BitbucketRepostitory] : [];
			} catch {
				return [];
			}
		};
	}, [overridenPermissionsSupplier]);
};
